import { useTranslation } from 'react-i18next'

import { BarcodeIcon, CoinsIcon, GlobeIcon, PackageIcon, ScalesIcon, TagIcon } from '@phosphor-icons/react'

import { filterNames } from '../constants'
import InventoryStatisticsSkeleton from './InventoryStatisticsSkeleton/InventoryStatisticsSkeleton'
import OverallComplianceProgressBar from './OverallComplianceProgressBar/OverallComplianceProgressBar'
import ScoreChart from './ScoreChart/ScoreChart'
import * as Styles from './styles'

const InventoryStatistics = ({
  loading,
  globalScorePercentage,
  hsCodesPercentage,
  missingHsCodesCount,
  identifiersPercentage,
  missingIdentifiersCount,
  countryOfOriginPercentage,
  missingCountryOfOriginCount,
  weightPercentage,
  missingWeightCount,
  unitCostPercentage,
  missingUnitCostCount,
  onChangeFilter,
  totalProducts,
  exportPricesPercentage,
  missingExportPricesCount,
}) => {
  const { t } = useTranslation()

  const handleOverallComplianceClick = () => onChangeFilter(filterNames.missing, 'any')
  const handleCountryOfOriginClick = () => onChangeFilter(filterNames.missing, 'country')
  const handleHsCodesClick = () => onChangeFilter(filterNames.missing, 'hs_code')
  const handleIdentifiersClick = () => onChangeFilter(filterNames.missing, 'identifiers')
  const handleUnitCostClick = () => onChangeFilter(filterNames.missing, 'unit_cost')
  const handleWeightClick = () => onChangeFilter(filterNames.missing, 'weight')
  const handleExportPricesClick = () => onChangeFilter(filterNames.missing, 'export_details')

  if (loading) return <InventoryStatisticsSkeleton />

  return (
    <Styles.Container>
      <OverallComplianceProgressBar
        percentage={globalScorePercentage}
        totalProducts={totalProducts}
        onClick={handleOverallComplianceClick}
      />
      <Styles.ChartsContainer>
        <ScoreChart
          title={t('País de origen')}
          titleIcon={<GlobeIcon />}
          tooltip={t(
            'Productos con país de origen. La aduana lo usa para aplicar los aranceles y acuerdos comerciales correctos.'
          )}
          percentage={countryOfOriginPercentage}
          missingCount={missingCountryOfOriginCount}
          onClick={handleCountryOfOriginClick}
        />
        <ScoreChart
          title={t('Códigos HS')}
          titleIcon={<PackageIcon />}
          tooltip={t(
            'Productos con un HS code válido. La aduana lo usa para clasificar cada producto y calcular aranceles e impuestos.'
          )}
          percentage={hsCodesPercentage}
          missingCount={missingHsCodesCount}
          onClick={handleHsCodesClick}
        />
        <ScoreChart
          title={t('Identificadores')}
          titleIcon={<BarcodeIcon />}
          tooltip={t(
            'Productos con los identificadores que exige la aduana de los países a los que envías: los PID de la UE (código de barras y NS-PID) y el MID y el código HTS de EE. UU. Los SKU se sincronizan desde Shopify, así que siempre están completos.'
          )}
          percentage={identifiersPercentage}
          missingCount={missingIdentifiersCount}
          onClick={handleIdentifiersClick}
        />
        <ScoreChart
          title={t('Coste unitario')}
          titleIcon={<CoinsIcon />}
          tooltip={t('Productos con coste unitario. Se usa para declarar el valor en aduana de cada envío.')}
          percentage={unitCostPercentage}
          missingCount={missingUnitCostCount}
          onClick={handleUnitCostClick}
        />
        <ScoreChart
          title={t('Peso')}
          titleIcon={<ScalesIcon />}
          tooltip={t('Productos con peso. Es necesario para declarar los envíos y calcular los costes de envío.')}
          percentage={weightPercentage}
          missingCount={missingWeightCount}
          onClick={handleWeightClick}
        />
        <ScoreChart
          title={t('Precios exportación')}
          titleIcon={<TagIcon />}
          tooltip={t(
            'Productos con precios de exportación válidos en todos los países donde tienes una subsidiaria importadora.'
          )}
          percentage={exportPricesPercentage}
          missingCount={missingExportPricesCount}
          onClick={handleExportPricesClick}
        />
      </Styles.ChartsContainer>
    </Styles.Container>
  )
}

export default InventoryStatistics
